import { render } from "./Details.vue?vue&type=template&id=e2e80458"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
script.render = render

export default script